const PIXEL_ID = '1636053654687251'

let initialized = false

export function initPixel() {
  if (initialized) return

  const f = window as any
  if (f.fbq) return

  const n: any = (f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })

  if (!f._fbq) f._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  const firstScript = document.getElementsByTagName('script')[0]
  firstScript?.parentNode?.insertBefore(script, firstScript)

  f.fbq('init', PIXEL_ID)
  initialized = true
}

export function trackEvent(eventName: string, params?: Record<string, any>) {
  const fbq = (window as any).fbq
  if (fbq) {
    if (params) {
      fbq('track', eventName, params)
    } else {
      fbq('track', eventName)
    }
  }
}
